import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-set";
import _classCallCheck from "/codebuild/output/src2321452795/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2321452795/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { stringifyRule } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { StyleSheetMirror } from '../utils.js';

var StylesheetManager = /*#__PURE__*/function () {
  function StylesheetManager(options) {
    _classCallCheck(this, StylesheetManager);

    this.trackedLinkElements = new WeakSet();
    this.styleMirror = new StyleSheetMirror();
    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }

  _createClass(StylesheetManager, [{
    key: "attachLinkElement",
    value: function attachLinkElement(linkEl, childSn) {
      if ('_cssText' in childSn.attributes) this.mutationCb({
        adds: [],
        removes: [],
        texts: [],
        attributes: [{
          id: childSn.id,
          attributes: childSn.attributes
        }]
      });
      this.trackLinkElement(linkEl);
    }
  }, {
    key: "trackLinkElement",
    value: function trackLinkElement(linkEl) {
      if (this.trackedLinkElements.has(linkEl)) return;
      this.trackedLinkElements.add(linkEl);
      this.trackStylesheetInLinkElement(linkEl);
    }
  }, {
    key: "adoptStyleSheets",
    value: function adoptStyleSheets(sheets, hostId) {
      if (sheets.length === 0) return;
      var adoptedStyleSheetData = {
        id: hostId,
        styleIds: []
      };
      var styles = [];

      var _iterator = _createForOfIteratorHelper(sheets),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var sheet = _step.value;
          var styleId = void 0;

          if (!this.styleMirror.has(sheet)) {
            styleId = this.styleMirror.add(sheet);
            styles.push({
              styleId: styleId,
              rules: Array.from(sheet.rules || CSSRule, function (r, index) {
                return {
                  rule: stringifyRule(r),
                  index: index
                };
              })
            });
          } else styleId = this.styleMirror.getId(sheet);

          adoptedStyleSheetData.styleIds.push(styleId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (styles.length > 0) adoptedStyleSheetData.styles = styles;
      this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.styleMirror.reset();
      this.trackedLinkElements = new WeakSet();
    }
  }, {
    key: "trackStylesheetInLinkElement",
    value: function trackStylesheetInLinkElement(linkEl) {}
  }]);

  return StylesheetManager;
}();

export { StylesheetManager };